import produce from 'immer'
import {
  AUTODESK_LOAD,
  AUTODESK_LOAD_SUCCESS,
  AUTODESK_LOAD_FAIL,
  AUTODESK_HUB_LOAD,
  AUTODESK_HUB_LOAD_SUCCESS,
  AUTODESK_HUB_LOAD_FAIL
} from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {}
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case AUTODESK_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case AUTODESK_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.data
        return
      }
      case AUTODESK_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })

export const reducerHub = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case AUTODESK_HUB_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case AUTODESK_HUB_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.data
        return
      }
      case AUTODESK_HUB_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
